"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIRECTION_INDEX_DATA = exports.PLAYER_EVENTS = exports.COLLIDER_TAGS = exports.MESSAGES = exports.SYSTEMS = void 0;
var SYSTEMS;
(function (SYSTEMS) {
    SYSTEMS[SYSTEMS["PLAYER_ACTION"] = 0] = "PLAYER_ACTION";
    SYSTEMS[SYSTEMS["PLAYER_MOVEMENT"] = 1] = "PLAYER_MOVEMENT";
    SYSTEMS[SYSTEMS["PLAYER_ANIMATION"] = 2] = "PLAYER_ANIMATION";
    SYSTEMS[SYSTEMS["PLAYER_MANAGER"] = 3] = "PLAYER_MANAGER";
    SYSTEMS[SYSTEMS["NPC_MOVEMENT"] = 4] = "NPC_MOVEMENT";
    SYSTEMS[SYSTEMS["POSITION"] = 5] = "POSITION";
    SYSTEMS[SYSTEMS["INPUT"] = 6] = "INPUT";
    SYSTEMS[SYSTEMS["PATHFINDING"] = 7] = "PATHFINDING";
    SYSTEMS[SYSTEMS["TIMER"] = 8] = "TIMER";
    SYSTEMS[SYSTEMS["TREE"] = 9] = "TREE";
    SYSTEMS[SYSTEMS["LEVEL"] = 10] = "LEVEL";
    SYSTEMS[SYSTEMS["INVENTORY"] = 11] = "INVENTORY";
    SYSTEMS[SYSTEMS["ITEM_DROP"] = 12] = "ITEM_DROP";
    SYSTEMS[SYSTEMS["DIALOGUE"] = 13] = "DIALOGUE";
    SYSTEMS[SYSTEMS["GAME_STATE"] = 14] = "GAME_STATE";
    SYSTEMS[SYSTEMS["FLOWER"] = 15] = "FLOWER";
    SYSTEMS[SYSTEMS["BUG_SPAWN"] = 16] = "BUG_SPAWN";
    SYSTEMS[SYSTEMS["BUG_MOVEMENT_AND_ANIMATION"] = 17] = "BUG_MOVEMENT_AND_ANIMATION";
    SYSTEMS[SYSTEMS["BUG_CATCH"] = 18] = "BUG_CATCH";
    SYSTEMS[SYSTEMS["BEE_KEEP"] = 19] = "BEE_KEEP";
    SYSTEMS[SYSTEMS["DIG"] = 20] = "DIG";
    SYSTEMS[SYSTEMS["NPC"] = 21] = "NPC";
    SYSTEMS[SYSTEMS["HOUSE"] = 22] = "HOUSE";
    SYSTEMS[SYSTEMS["SHOP"] = 23] = "SHOP";
})(SYSTEMS = exports.SYSTEMS || (exports.SYSTEMS = {}));
var MESSAGES;
(function (MESSAGES) {
    MESSAGES[MESSAGES["EQUIPPED_SHOVEL"] = 0] = "EQUIPPED_SHOVEL";
    MESSAGES[MESSAGES["EQUIPPED_NET"] = 1] = "EQUIPPED_NET";
    MESSAGES[MESSAGES["PLAYER_HONEY_UPDATE"] = 2] = "PLAYER_HONEY_UPDATE";
    MESSAGES[MESSAGES["PLACE_FURNITURE"] = 3] = "PLACE_FURNITURE";
    MESSAGES[MESSAGES["REMOVE_FURNITURE"] = 4] = "REMOVE_FURNITURE";
    MESSAGES[MESSAGES["ADDED_INVENTORY_ITEM"] = 5] = "ADDED_INVENTORY_ITEM";
    MESSAGES[MESSAGES["REMOVED_INVENTORY_ITEM"] = 6] = "REMOVED_INVENTORY_ITEM";
    MESSAGES[MESSAGES["FINISHED_TUTORIAL"] = 7] = "FINISHED_TUTORIAL";
    MESSAGES[MESSAGES["FINISH_NPC_TASK"] = 8] = "FINISH_NPC_TASK";
    MESSAGES[MESSAGES["GAME_STATE_INITIALIZED"] = 9] = "GAME_STATE_INITIALIZED";
    MESSAGES[MESSAGES["INITIAL_MAP_LOADED"] = 10] = "INITIAL_MAP_LOADED";
    MESSAGES[MESSAGES["CLIENT_PLAYER_ENTITY_INITIALIZED"] = 11] = "CLIENT_PLAYER_ENTITY_INITIALIZED";
    MESSAGES[MESSAGES["DROP_ITEM"] = 12] = "DROP_ITEM";
    MESSAGES[MESSAGES["PICKUP_ITEM"] = 13] = "PICKUP_ITEM";
    MESSAGES[MESSAGES["EQUIP_ITEM"] = 14] = "EQUIP_ITEM";
    MESSAGES[MESSAGES["USE_ITEM"] = 15] = "USE_ITEM";
    MESSAGES[MESSAGES["REMOVE_DROPPED_ITEM"] = 16] = "REMOVE_DROPPED_ITEM";
    MESSAGES[MESSAGES["INVENTORY_ERROR"] = 17] = "INVENTORY_ERROR";
    MESSAGES[MESSAGES["NEW_FLOWER"] = 18] = "NEW_FLOWER";
    MESSAGES[MESSAGES["PLANTED_TREE"] = 19] = "PLANTED_TREE";
    MESSAGES[MESSAGES["REMOVED_TREE"] = 20] = "REMOVED_TREE";
    MESSAGES[MESSAGES["REMOVED_FLOWER"] = 21] = "REMOVED_FLOWER";
    MESSAGES[MESSAGES["FLOWER_FULLY_GROWN"] = 22] = "FLOWER_FULLY_GROWN";
    MESSAGES[MESSAGES["SPAWNED_BUG"] = 23] = "SPAWNED_BUG";
    MESSAGES[MESSAGES["REMOVED_BUG"] = 24] = "REMOVED_BUG";
    MESSAGES[MESSAGES["START_TIMERS"] = 25] = "START_TIMERS";
    MESSAGES[MESSAGES["ADDED_HOLE"] = 26] = "ADDED_HOLE";
    MESSAGES[MESSAGES["REMOVED_HOLE"] = 27] = "REMOVED_HOLE";
})(MESSAGES = exports.MESSAGES || (exports.MESSAGES = {}));
var COLLIDER_TAGS;
(function (COLLIDER_TAGS) {
    COLLIDER_TAGS["furniture"] = "furniture";
    COLLIDER_TAGS["building"] = "building";
    COLLIDER_TAGS["hole"] = "hole";
    COLLIDER_TAGS["flower"] = "flower";
    COLLIDER_TAGS["bug"] = "bug";
    COLLIDER_TAGS["blocking"] = "blocking";
    COLLIDER_TAGS["sort"] = "sort";
    COLLIDER_TAGS["tree"] = "tree";
    COLLIDER_TAGS["tree_stump"] = "tree_stump";
    COLLIDER_TAGS["client_player"] = "client_player";
    COLLIDER_TAGS["in_front_of_client_player"] = "in_front_of_client_player";
    COLLIDER_TAGS["client_player_bug_detector"] = "client_player_bug_detector";
    COLLIDER_TAGS["player"] = "player";
    COLLIDER_TAGS["dropped_item"] = "dropped_item";
    COLLIDER_TAGS["prevent_hole"] = "prevent_hole";
    COLLIDER_TAGS["npc"] = "npc";
    COLLIDER_TAGS["water"] = "water";
})(COLLIDER_TAGS = exports.COLLIDER_TAGS || (exports.COLLIDER_TAGS = {}));
var PLAYER_EVENTS;
(function (PLAYER_EVENTS) {
    PLAYER_EVENTS["INVENTORY_CHANGE"] = "inventory_change";
})(PLAYER_EVENTS = exports.PLAYER_EVENTS || (exports.PLAYER_EVENTS = {}));
exports.DIRECTION_INDEX_DATA = {
    DIRECTIONS_NAMES: ["east", "north", "west", "south"],
    NAMES_TO_INDEX: {
        "east": 0,
        "north": 1,
        "west": 2,
        "south": 3,
    },
    ROTATIONS: [180, 90, 0, 270]
};
//# sourceMappingURL=module.js.map